/* Home story video (2026-10-16): the muted looping video is loaded and started only when it comes near the screen, and
   paused again when it leaves (saves data and battery). Not started for reduced motion or Data Saver: then the poster stays. */
(function () {
  'use strict';
  var vids = document.querySelectorAll('video[data-hv-video]');
  if (!vids.length) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var saver = navigator.connection && navigator.connection.saveData;
  if (reduce || saver || !('IntersectionObserver' in window)) return;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var v = e.target;
      if (e.isIntersecting) {
        if (!v.getAttribute('src')) v.src = v.getAttribute('data-src');
        var p = v.play(); if (p && p.catch) p.catch(function () {});
      } else if (v.getAttribute('src')) {
        v.pause();
      }
    });
  }, { rootMargin: '150px 0px', threshold: 0.15 });
  vids.forEach(function (v) { io.observe(v); });
})();
